import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Box, Tab, Tabs } from '@mui/material';
import { tabsClasses } from '@mui/material/Tabs';

import PodsList from './pods_list';
import IndoorPartnersList from './indoor_partners_list';
import EvenRegisterList from './even_register_list';
import PageHeader from '../../common/page_header';

const PodsPage = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [tab, setTab] = useState(location?.state?.tab || 0);

    const onTabChange = (tabValue) => {
        navigate(location.pathname, {});
        setTab(tabValue);
    };

    const renderView = () => {
        if (tab === 0) {
            return <PodsList tab={ tab }/>;
        } else if (tab === 1) {
            return <IndoorPartnersList tab={ tab }/>;
        }

        return <EvenRegisterList tab={ tab }/>;
    };

    return (
        <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1, gap: 3, mb: 4 } }>
            <PageHeader title="Punkty sprzedaży"/>

            <Box sx={ { borderBottom: 1, borderColor: 'divider' } }>
                <Tabs
                    value={ tab }
                    onChange={ (_, value) => onTabChange(value) }
                    variant="scrollable"
                    scrollButtons="auto"
                    sx={ {
                        [`& .${ tabsClasses.scrollButtons }`]: {
                            '&.Mui-disabled': { opacity: 0.3 },
                        },
                    } }
                >
                    <Tab label="Punkty sprzedaży"/>
                    <Tab label="Partnerzy handlowi"/>
                    <Tab label="Rejestr zdarzeń"/>
                </Tabs>
            </Box>

            <Box sx={ { display: 'flex', flexDirection: 'column', flexGrow: 1 } }>
                { renderView() }
            </Box>
        </Box>
    );
};

export default PodsPage;